import type { AdContent, AdType } from "@models/Ad.model";
import { Ad } from "@models/Ad.model";
import { AdSerializer } from "@models/serializers/adSerializer";
import { httpRequest } from "../../http";

export type CreateAdPayload = {
  name: string;
  type: AdType;
  subtype?: AdType | null;
  organization_id?: number;
  is_template?: boolean;
  is_default?: boolean;
  content?: AdContent;
  parent_id?: number | null;
};

export class CommandCreateAd {
  async run(payload: CreateAdPayload) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/`;

    try {
      const response = await httpRequest<any>(url, {
        method: "POST",
        body: payload,
      });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error creating ad:", error);
      throw error;
    }
  }

  deserialize(data: any): Ad {
    const serializer = new AdSerializer();
    return serializer.deserialize(data);
  }
}
